// Hook do pobierania podtypów polityki dla danego tagu

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IPolicySubtype {
  value: string;
  text: string;
}

interface IResponse {
  items: IPolicySubtype[];
}

const getPolicySubtypes = (tag: string): Promise<IResponse> =>
  axios.get('/dev-studio/process/policy-subtypes', { params: { tag } });

export const useGetPolicySubtypes = (
  tag: string | null,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    ['policySubtypes', tag],
    () => getPolicySubtypes(tag as string),
    {
      enabled: !!tag,
      ...options,
    }
  );
